import React from 'react';
import { Col, Input } from 'antd';
import FormItem from '@/components/ui/FormItem';

interface OrganizationProps {
	disabled?: boolean;
}

export function Organization({ disabled = true }: Readonly<OrganizationProps>): JSX.Element {
	return (
		<Col xs={24} sm={12}>
			<FormItem labelCol={{ span: 24 }} name={['organization_id']} label="Company">
				<Input disabled={disabled} size="large" />
			</FormItem>
		</Col>
	);
}
